import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import moment from 'moment';

// Icons 

import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStatusColor from '../../../util/style/getStatusColor';
import { getDoctor, getGroup, getGroupSize, getTeamMember } from '../../../routes/hacker/users';
import { useAppSelector } from '../../../redux/hooks';
import getCapitalizedString from '../../../util/style/getCapitalizedString';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

type Props = {
    item: any; 
};


const ReferralRow: React.FC<Props> = ({ item }) => {

  const colors = useAppSelector(state => state.theme.colors); 
  const selectedReferral = useAppSelector((state) => state.referralsAccess.selectedReferral); 

  const [doctorName, setDoctorName] = useState(''); 
  const [teamMemberName, setTeamMemberName] = useState(''); 

  // -- 

  const handleDoctor = async () => { 

      const res = await getDoctor(item.doctorId) as any; 

      if (res?.data.status === 200) { 

        setDoctorName(`${res.data.doctor.firstName} ${res.data.doctor.lastName}`); 
          
      }; 

  }; 

  // -- 

  const handleTeamMember = async () => { 

      const res = await getTeamMember(item.teamMemberId) as any; 

      if (res?.data.status === 200) { 

        setDoctorName(`${res.data.teamMember.firstName} ${res.data.teamMember.lastName}`); 
          
      }; 

  }; 

  // -- 

  useEffect(() => { 

    handleDoctor(); 

    handleTeamMember(); 

  },[item]); 

  return (

    <Box 
      sx={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      width: '100%',
      fontSize: 12, 
      height: 50,
      backgroundColor: (selectedReferral?._id == item?._id) ? colors?.sectionHover : 'transparent', 
      '&:hover': { backgroundColor: colors?.sectionHover }
    }}>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center',
                width: '28%',
                marginLeft: '2%',  
                textAlign: 'left',
                overflow: 'hidden',
            }}>

              <CardGiftcardIcon sx={{ marginRight: 3, color: 'rgb(209, 86, 15)' }} />
              
              {teamMemberName}
              
            </div>

            <div style={{ 
                width: '20%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{doctorName}</div>

            <div style={{ 
                width: '20%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{moment.utc(item?.updatedAt).format('LL')}</div>

            <div style={{ 
                width: '10%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>                
            
              <strong 
                style={{ 
                  padding: 5,
                  borderRadius: 7,
                  backgroundColor: getStatusColor(item?.status), 
                  color: 'white', 
                }}>
              {getCapitalizedString(item?.status)}
              </strong>
          </div>

            <div style={{ 
                width: '5%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>
                <Box
                  sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    '&:hover': { backgroundColor: 'rgba(45, 153, 207, 0.6)'}
                  }}
                >
                  <MoreVertIcon></MoreVertIcon>
                </Box>

            </div>

    </Box>

  );

};

export default ReferralRow;